// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"V8-z"};